import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/schema-that-actually-moves-the-needle")(blogRouteOptions("schema-that-actually-moves-the-needle"));
